module.exports = __webpack_public_path__ + "img/verse.debcaa2d.gif";